module.exports = function(innerStore) {

	var cache = null;

	var createId = function() {
		return (new Date()).getTime()
			+ '.'
			+ Math.floor(Math.random() * 10)
			+ Math.floor(Math.random() * 10)
			+ Math.floor(Math.random() * 10)
			+ Math.floor(Math.random() * 10)
		;
	}; // local createId()

	var indexOf = function(needle, haystack) {
		for (var i = 0; i < haystack.length; i++) {
			if (haystack[i] && haystack[i].$id == needle.$id) {
				return i;
			}
		}
		return -1;
	};

	this.getIndex = async function() {
		return this.getAll();
	}; // getIndex()

	this.getAll = async function() {
		if (!cache) {
			return innerStore.get().then(function(items) {
				items = items || [];
				cache = items
					.filter(function(item) {
						return item;
					})
					.map(function(item) {
						item.$id = item.$id || createId();
						return item;
					})
				;
				return cache;
			});
		} else {
			return cache;
		}
	}; // getAll()

	this.saveAll = async function(items) {
		cache = null;
		return innerStore.save(items);
	}; // saveAll()

	this.get = async function($id) {
		return this.getAll().then(function(items) {
			return items[indexOf({$id: $id}, items)];
		});
	}; // getItem()

	this.save = async function(item) {
		return this.getAll().then(function(items) {
			item.$id = item.$id || createId();
			var index = indexOf(item, items);
			items[index > -1 ? index : items.length] = item;
			cache = null;
			return innerStore.save(items).then(function() {
				return item.$id;
			});
		});
	}; // save()

	this.remove = async function($id) {
		return this.getAll().then(function(items) {
			cache = null;
			var index = indexOf({$id: $id}, items);
			if (index > -1) {
				items.splice(index, 1);
				return innerStore.save(items).then(function() {
					return true;
				});
			} else {
				return false;
			}
		});
	}; // remove()

};
